import { render } from "./Select.vue?vue&type=template&id=04f73292&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=04f73292&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04f73292"

export default script